// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"step-3_subtitle__k93sF","stickerTreeBlock":"step-3_stickerTreeBlock__1AX1O"};